/* tslint:disable */
/* eslint-disable */
/**
 * Opus API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface TimesheetReportEntry
 */
export interface TimesheetReportEntry {
  /**
   *
   * @type {string}
   * @memberof TimesheetReportEntry
   */
  name: string
  /**
   * Contains contracted core hours in the order of: Q1, Q2, Q3, Q4, Annual
   *
   * @type {Array<number>}
   * @memberof TimesheetReportEntry
   */
  coreHours: Array<number>
  /**
   * Contains the hours entered into the timesheet in the order of: Q1, Q2, Q3, Q4, Annual
   *
   * @type {Array<number>}
   * @memberof TimesheetReportEntry
   */
  realHours: Array<number>
  /**
   * Contains floor( (realHours / coreHours) * 100 ). This could be calculated on the fly but providing
   * it precalculated makes frontend life simpler when doing conditional formatting.
   *
   * @type {Array<number>}
   * @memberof TimesheetReportEntry
   */
  percentage: Array<number>
}

/**
 * Check if a given object implements the TimesheetReportEntry interface.
 */
export function instanceOfTimesheetReportEntry(value: object): value is TimesheetReportEntry {
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('coreHours' in value) || value['coreHours'] === undefined) return false
  if (!('realHours' in value) || value['realHours'] === undefined) return false
  if (!('percentage' in value) || value['percentage'] === undefined) return false
  return true
}

export function TimesheetReportEntryFromJSON(json: any): TimesheetReportEntry {
  return TimesheetReportEntryFromJSONTyped(json, false)
}

export function TimesheetReportEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimesheetReportEntry {
  if (json == null) {
    return json
  }
  return {
    name: json['name'],
    coreHours: json['coreHours'],
    realHours: json['realHours'],
    percentage: json['percentage'],
  }
}

export function TimesheetReportEntryToJSON(value?: TimesheetReportEntry | null): any {
  if (value == null) {
    return value
  }
  return {
    name: value['name'],
    coreHours: value['coreHours'],
    realHours: value['realHours'],
    percentage: value['percentage'],
  }
}
